import React from 'react';
import { Button, Skeleton } from '@mui/material';

function HomePageLoadingSkeleton() {
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <Button variant="outlined" disabled style={{ borderRadius: '50%', margin: '0 10px' }}>
          Loading
        </Button>
        <Button variant="outlined" disabled style={{ borderRadius: '50%', margin: '0 10px' }}>
          Loading
        </Button>
        <Button variant="outlined" disabled style={{ borderRadius: '50%', margin: '0 10px' }}>
          Loading
        </Button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
        <Button variant="outlined" disabled style={{ margin: '5px' }}>
          Loading
        </Button>
        <Button variant="outlined" disabled style={{ margin: '5px' }}>
          Loading
        </Button>
        <Skeleton variant="circular" width={100} height={100} style={{ margin: '20px' }} />
        <Skeleton variant="circular" width={100} height={100} style={{ margin: '20px' }} />
      </div>
      <div style={{display: 'flex', flexDirection:'column', textAlign: 'center', padding: '20px', justifyContent: 'center', alignItems: 'center' }}>
        <Skeleton height={30} width="40%" />
        <Skeleton height={30} width="40%" />
      </div>
    </div>
  );
}

export default HomePageLoadingSkeleton;
